import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function PublicNav() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const links = [["How It Works", "/how-it-works"], ["AI Matchmaking", "/#ai"], ["Pricing", "/pricing"], ["Safety", "/safety"], ["FAQ", "/faq"]];
  return (
    <header className="sticky top-0 z-50 bg-[#FDFBF7]/90 backdrop-blur-md border-b border-[#E8DFD1]" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="font-serif font-bold text-2xl text-[#58111A]">Mana<span className="text-[#C59B27]">Jodi</span></Link>
        <nav className="hidden md:flex items-center gap-7">
          {links.map(([l, to]) => <Link key={l} to={to} className="text-sm font-medium text-[#605255] hover:text-[#781826] transition">{l}</Link>)}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link to="/app/dashboard" className="btn-primary text-sm">Go to Dashboard</Link>
          ) : (
            <>
              <button onClick={() => nav("/login")} className="text-sm font-semibold text-[#781826]" data-testid="nav-login">Login</button>
              <button onClick={() => nav("/register")} className="btn-primary text-sm" data-testid="nav-register">Create Free Profile</button>
            </>
          )}
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)}>{open ? <X className="w-5 h-5 text-[#58111A]" /> : <Menu className="w-5 h-5 text-[#58111A]" />}</button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E8DFD1] bg-[#FDFBF7] px-4 py-4 space-y-3">
          {links.map(([l, to]) => <Link key={l} to={to} onClick={() => setOpen(false)} className="block text-sm font-medium text-[#605255]">{l}</Link>)}
          {user ? (
            <Link to="/app/dashboard" className="btn-primary text-sm w-full">Go to Dashboard</Link>
          ) : (
            <div className="flex gap-2 pt-2">
              <button onClick={() => nav("/login")} className="btn-outline text-sm flex-1">Login</button>
              <button onClick={() => nav("/register")} className="btn-primary text-sm flex-1">Register</button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
